import React, { useMemo, useState } from 'react';

import { Icon } from '../../shared/icon/Icon';
import { CaretDown, CaretSide } from '../../shared/icons';
import styles from './NettingEngine.module.scss';

interface NettingEngineJurisdictionResultsSectionProps {
    label: string;
    children: JSX.Element;
}

export const NettingEngineJurisdictionResultsSection: React.FC<NettingEngineJurisdictionResultsSectionProps> = ({ label, children }) => {
    const [sectionOpen, setSectionOpen] = useState<boolean>(true);

    const sectionOpenIcon = useMemo(() => sectionOpen ? CaretDown : CaretSide, [sectionOpen]);

    const body = useMemo(() => sectionOpen ? children : null, [sectionOpen, children]);

    return (
        <div className={styles.resultsSectionWrapper}>
            <div className={styles.detailsTitle} onClick={() => setSectionOpen(!sectionOpen)}>
                {label}
                <div className={styles.collapseIcon}><Icon icon={sectionOpenIcon} fontSize={14} /></div>
            </div>
            {body}
        </div>
    );
};
